import {
    CREATE_OQ_CLIENT,
    CREATE_OQ_CLIENT_SUCCESS,
    CREATE_OQ_CLIENT_ERROR,
    CREATE_OQ_EMPLOYEE,
    CREATE_OQ_EMPLOYEE_SUCCESS,
    CREATE_OQ_EMPLOYEE_ERROR,
    DELETE_OQ_CLIENT,
    DELETE_OQ_CLIENT_SUCCESS,
    DELETE_OQ_CLIENT_ERROR,
    DELETE_OQ_EMPLOYEE,
    DELETE_OQ_EMPLOYEE_SUCCESS,
    DELETE_OQ_EMPLOYEE_ERROR,
    GET_OQ_CLIENT,
    GET_OQ_CLIENT_SUCCESS,
    GET_OQ_CLIENT_ERROR,
    GET_OQ_PROFILE,
    GET_OQ_PROFILE_SUCCESS,
    GET_OQ_PROFILE_ERROR,
    GET_OQ_ADMINISTRATION_URL,
    GET_OQ_ADMINISTRATION_URL_SUCCESS,
    GET_OQ_ADMINISTRATION_URL_ERROR,
    SEND_OQ_ADMINISTRATION_SMS,
    SEND_OQ_ADMINISTRATION_SMS_SUCCESS,
    SEND_OQ_ADMINISTRATION_SMS_ERROR,
    SEND_OQ_ADMINISTRATION_EMAIL,
    SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS,
    SEND_OQ_ADMINISTRATION_EMAIL_ERROR,
    GET_OQ_SCHEDULE,
    GET_OQ_SCHEDULE_SUCCESS,
    GET_OQ_SCHEDULE_ERROR,
    SET_OQ_SCHEDULE,
    SET_OQ_SCHEDULE_SUCCESS,
    SET_OQ_SCHEDULE_ERROR,
    STOP_OQ_SCHEDULE,
    STOP_OQ_SCHEDULE_SUCCESS,
    STOP_OQ_SCHEDULE_ERROR,
    GET_PATIENT_DEVICE_STATUS,
    GET_PATIENT_DEVICE_STATUS_SUCCESS,
    GET_PATIENT_DEVICE_STATUS_ERROR,
    SEND_OQ_ADMINISTRATION_PUSH,
    SEND_OQ_ADMINISTRATION_PUSH_SUCCESS,
    SEND_OQ_ADMINISTRATION_PUSH_ERROR,
} from './constants';
import {
    CreateOQClientData,
    CreateOQClientAction,
    CreateOQClientSuccessAction,
    CreateOQClientErrorAction,
    CreateOQEmployeeData,
    CreateOQEmployeeAction,
    CreateOQEmployeeSuccessAction,
    CreateOQEmployeeErrorAction,
    DeleteOQClientData,
    DeleteOQClientAction,
    DeleteOQClientSuccessAction,
    DeleteOQClientErrorAction,
    DeleteOQEmployeeData,
    DeleteOQEmployeeAction,
    DeleteOQEmployeeSuccessAction,
    DeleteOQEmployeeErrorAction,
    DeleteOQResult,
    GetOQProfileData,
    GetOQProfileAction,
    GetOQProfileSuccessAction,
    GetOQProfileErrorAction,
    GetOQClientData,
    OQClientData,
    GetOQClientAction,
    GetOQClientSuccessAction,
    GetOQClientErrorAction,
    GetOQAdministrationURLData,
    GetOQAdministrationURLAction,
    GetOQAdministrationURLSuccessAction,
    GetOQAdministrationURLErrorAction,
    SendOQAdministrationSMSData,
    SendOQAdministrationSMSAction,
    SendOQAdministrationSMSSuccessAction,
    SendOQAdministrationSMSErrorAction,
    SendOQAdministrationEmailData,
    SendOQAdministrationEmailAction,
    SendOQAdministrationEmailSuccessAction,
    SendOQAdministrationEmailErrorAction,
    OQScheduleData,
    GetOQScheduleData,
    GetOQScheduleAction,
    GetOQScheduleSuccessAction,
    GetOQScheduleErrorAction,
    SetOQScheduleData,
    SetOQScheduleAction,
    SetOQScheduleSuccessAction,
    SetOQScheduleErrorAction,
    StopOQScheduleData,
    StopOQScheduleAction,
    StopOQScheduleSuccessAction,
    StopOQScheduleErrorAction,
    PatientDeviceStatus,
    GetPatientDeviceStatusData,
    GetPatientDeviceStatusAction,
    GetPatientDeviceStatusSuccessAction,
    GetPatientDeviceStatusErrorAction,
    SendOQAdministrationPushData,
    SendOQAdministrationPushAction,
    SendOQAdministrationPushSuccessAction,
    SendOQAdministrationPushErrorAction,
} from './types';

export function createOQClient(client: CreateOQClientData): CreateOQClientAction {
    return {
        type: CREATE_OQ_CLIENT,
        data: client,
    };
};

export function createOQClientSuccess(client: unknown): CreateOQClientSuccessAction {
    return {
        type: CREATE_OQ_CLIENT_SUCCESS,
        data: client,
    };
};

export function createOQClientError(data: string): CreateOQClientErrorAction {
    return {
        type: CREATE_OQ_CLIENT_ERROR,
        data,
    };
};

export function createOQEmployee(employee: CreateOQEmployeeData): CreateOQEmployeeAction {
    return {
        type: CREATE_OQ_EMPLOYEE,
        data: employee,
    };
};

export function createOQEmployeeSuccess(employee: unknown): CreateOQEmployeeSuccessAction {
    return {
        type: CREATE_OQ_EMPLOYEE_SUCCESS,
        data: employee,
    };
};

export function createOQEmployeeError(data: string): CreateOQEmployeeErrorAction {
    return {
        type: CREATE_OQ_EMPLOYEE_ERROR,
        data,
    };
};

export function deleteOQClient(client: DeleteOQClientData): DeleteOQClientAction {
    return {
        type: DELETE_OQ_CLIENT,
        data: client,
    };
};

export function deleteOQClientSuccess(
    data: { patientId: string; result: DeleteOQResult },
): DeleteOQClientSuccessAction {
    return {
        type: DELETE_OQ_CLIENT_SUCCESS,
        data,
    };
};

export function deleteOQClientError(message: string): DeleteOQClientErrorAction {
    return {
        type: DELETE_OQ_CLIENT_ERROR,
        data: message,
    };
};

export function deleteOQEmployee(employee: DeleteOQEmployeeData): DeleteOQEmployeeAction {
    return {
        type: DELETE_OQ_EMPLOYEE,
        data: employee,
    };
};

export function deleteOQEmployeeSuccess(
    data: { employeeId: string; result: DeleteOQResult },
): DeleteOQEmployeeSuccessAction {
    return {
        type: DELETE_OQ_EMPLOYEE_SUCCESS,
        data,
    };
};

export function deleteOQEmployeeError(message: string): DeleteOQEmployeeErrorAction {
    return {
        type: DELETE_OQ_EMPLOYEE_ERROR,
        data: message,
    };
};


export function getOQProfile(user: GetOQProfileData): GetOQProfileAction {
    return {
        type: GET_OQ_PROFILE,
        data: user,
    };
};

export function getOQProfileSuccess(data: unknown): GetOQProfileSuccessAction {
    return {
        type: GET_OQ_PROFILE_SUCCESS,
        data,
    };
};

export function getOQProfileError(data: string): GetOQProfileErrorAction {
    return {
        type: GET_OQ_PROFILE_ERROR,
        data,
    };
};

export function getOQClient(client: GetOQClientData): GetOQClientAction {
    return {
        type: GET_OQ_CLIENT,
        data: client,
    };
};

export function getOQClientSuccess(client: OQClientData): GetOQClientSuccessAction {
    return {
        type: GET_OQ_CLIENT_SUCCESS,
        data: client,
    };
};

export function getOQClientError(data: string): GetOQClientErrorAction {
    return {
        type: GET_OQ_CLIENT_ERROR,
        data,
    };
};

export function getOQAdministrationURL(client: GetOQAdministrationURLData): GetOQAdministrationURLAction {
    return {
        type: GET_OQ_ADMINISTRATION_URL,
        data: client,
    };
};

// define the data somewhere based on OQ docs
export function getOQAdministrationURLSuccess(url: string): GetOQAdministrationURLSuccessAction {
    return {
        type: GET_OQ_ADMINISTRATION_URL_SUCCESS,
        data: url,
    };
};

export function getOQAdministrationURLError(data: string): GetOQAdministrationURLErrorAction {
    return {
        type: GET_OQ_ADMINISTRATION_URL_ERROR,
        data,
    };
};

export function sendOQAdministrationSMS(client: SendOQAdministrationSMSData): SendOQAdministrationSMSAction {
    return {
        type: SEND_OQ_ADMINISTRATION_SMS,
        data: client,
    };
};

export function sendOQAdministrationSMSSuccess(data: unknown): SendOQAdministrationSMSSuccessAction {
    return {
        type: SEND_OQ_ADMINISTRATION_SMS_SUCCESS,
        data,
    };
};

export function sendOQAdministrationSMSError(data: string): SendOQAdministrationSMSErrorAction {
    return {
        type: SEND_OQ_ADMINISTRATION_SMS_ERROR,
        data,
    };
};

export function sendOQAdministrationEmail(
    data: SendOQAdministrationEmailData,
): SendOQAdministrationEmailAction {
    return {
        type: SEND_OQ_ADMINISTRATION_EMAIL,
        data,
    };
};

export function sendOQAdministrationEmailSuccess(data: unknown): SendOQAdministrationEmailSuccessAction {
    return {
        type: SEND_OQ_ADMINISTRATION_EMAIL_SUCCESS,
        data,
    };
};

export function sendOQAdministrationEmailError(data: string): SendOQAdministrationEmailErrorAction {
    return {
        type: SEND_OQ_ADMINISTRATION_EMAIL_ERROR,
        data,
    };
};

export function getOQSchedule(data: GetOQScheduleData): GetOQScheduleAction {
    return {
        type: GET_OQ_SCHEDULE,
        data,
    };
};

export function getOQScheduleSuccess(schedule: OQScheduleData | null): GetOQScheduleSuccessAction {
    return {
        type: GET_OQ_SCHEDULE_SUCCESS,
        data: schedule,
    };
};

export function getOQScheduleError(data: unknown): GetOQScheduleErrorAction {
    return {
        type: GET_OQ_SCHEDULE_ERROR,
        data,
    };
};

export function setOQSchedule(data: SetOQScheduleData): SetOQScheduleAction {
    return {
        type: SET_OQ_SCHEDULE,
        data,
    };
};

export function setOQScheduleSuccess(schedule: OQScheduleData): SetOQScheduleSuccessAction {
    return {
        type: SET_OQ_SCHEDULE_SUCCESS,
        data: schedule,
    };
};

export function setOQScheduleError(data: unknown): SetOQScheduleErrorAction {
    return {
        type: SET_OQ_SCHEDULE_ERROR,
        data,
    };
};

export function stopOQSchedule(data: StopOQScheduleData): StopOQScheduleAction {
    return {
        type: STOP_OQ_SCHEDULE,
        data,
    };
};

export function stopOQScheduleSuccess(): StopOQScheduleSuccessAction {
    return {
        type: STOP_OQ_SCHEDULE_SUCCESS,
    };
};

export function stopOQScheduleError(data: unknown): StopOQScheduleErrorAction {
    return {
        type: STOP_OQ_SCHEDULE_ERROR,
        data,
    };
};


export function getPatientDeviceStatus(data: GetPatientDeviceStatusData): GetPatientDeviceStatusAction {
    return { type: GET_PATIENT_DEVICE_STATUS, data };
}

export function getPatientDeviceStatusSuccess(data: PatientDeviceStatus): GetPatientDeviceStatusSuccessAction {
    return { type: GET_PATIENT_DEVICE_STATUS_SUCCESS, data };
}

export function getPatientDeviceStatusError(data: string): GetPatientDeviceStatusErrorAction {
    return { type: GET_PATIENT_DEVICE_STATUS_ERROR, data };
}

export function sendOQAdministrationPush(data: SendOQAdministrationPushData): SendOQAdministrationPushAction {
    return { type: SEND_OQ_ADMINISTRATION_PUSH, data };
}

export function sendOQAdministrationPushSuccess(data: unknown): SendOQAdministrationPushSuccessAction {
    return { type: SEND_OQ_ADMINISTRATION_PUSH_SUCCESS, data };
}

export function sendOQAdministrationPushError(data: string): SendOQAdministrationPushErrorAction {
    return { type: SEND_OQ_ADMINISTRATION_PUSH_ERROR, data };
}
